"use client";

import {
    DEFAULT_SPEECH_AUDIO_LEVELS,
    SPEECH_LEVEL_BAND_COUNT,
} from "@/lib/prism/stt/mic-audio-pipeline";

const MIN_BAR_HEIGHT_PX = 4;
const MAX_BAR_HEIGHT_PX = 14;

type SpeechLevelBarsProps = {
    levels?: number[];
    /** When true, bars stay at a calm mid height (no motion). */
    reducedMotion?: boolean;
};

function barHeight(level: number): number {
    const clamped = Math.max(0, Math.min(1, level));
    return MIN_BAR_HEIGHT_PX + clamped * (MAX_BAR_HEIGHT_PX - MIN_BAR_HEIGHT_PX);
}

export function SpeechLevelBars({
    levels = DEFAULT_SPEECH_AUDIO_LEVELS,
    reducedMotion = false,
}: SpeechLevelBarsProps) {
    const displayLevels = levels.slice(0, SPEECH_LEVEL_BAND_COUNT);
    while (displayLevels.length < SPEECH_LEVEL_BAND_COUNT) {
        displayLevels.push(DEFAULT_SPEECH_AUDIO_LEVELS[displayLevels.length] ?? 0.18);
    }

    return (
        <span
            className="flex items-end justify-center gap-0.5"
            aria-hidden="true"
        >
            {displayLevels.map((level, index) => {
                const height = reducedMotion ? (MIN_BAR_HEIGHT_PX + MAX_BAR_HEIGHT_PX) / 2 : barHeight(level);
                return (
                    <span
                        key={index}
                        className="w-0.5 rounded-full bg-accent transition-[height] duration-75 ease-out"
                        style={{ height: `${height}px` }}
                    />
                );
            })}
        </span>
    );
}
